import { BaseWizardStep } from '../base.wizard.step';

import { ApiService } from '@nrwl/common-lib';

export class AtaThresholdWizardStep extends BaseWizardStep {
  constructor(apiService: ApiService, config: any, parent: any) {
    super(apiService, config, parent);

    if (this.config.def.subContent) {
      this.subContent = new AtaThresholdWizardStep(
        apiService,
        config.def.subContent,
        this
      );
    }
  }
}
